import Vue from 'vue'
import * as selectors from '../components/selectors'

for (const selectorIndex in selectors) {
  const selector = selectors[selectorIndex]
  Vue.component(selector.name, selector)
}
